import React, { Component } from 'react';
import ghsLabelMapper from '../../../utils/ghsLabelMapper';

import './index.scss';

class SdsButtons extends Component {
  state = {
    selected: []
  };

  componentDidMount() {
    this.syncSelectedFromProps(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentValue !== this.props.currentValue) {
      this.syncSelectedFromProps(this.props);
    }
  }

  syncSelectedFromProps = props => {
    const { currentValue } = props;

    if (currentValue == null) {
      this.setState({ selected: [] });
      return;
    }
    const valuesArray = Array.isArray(currentValue)
      ? currentValue
      : [currentValue];

    const selected = valuesArray.map(v => String(v));
    this.setState({ selected });
  };

  handleSelectedButton = index => {
    const { disabled, handleButtonClick } = this.props;
    if (disabled) return;

    this.setState(
      prevState => {
        const current = prevState.selected || [];
        let next;
        if (current.includes(index)) {
          next = current.filter(i => i !== index);
        } else {
          next = [...current, index];
        }

        return { selected: next };
      },
      () => {
        if (typeof handleButtonClick === 'function') {
          handleButtonClick(this.state.selected);
        }
      }
    );
  };

  getClassNames = index => {
    const { disabled } = this.props;
    const { selected } = this.state;

    let className = 'sdsButtons-button';

    if (selected.includes(index)) {
      className += ' activeButton';
    }

    if (disabled) {
      className += ' disabledButton disabled';
    }

    return className;
  };

  render() {
    const { disabled } = this.props;

    const buttons = ['0', '1', '2', '3', '4', '5', '6', '7', '8'];

    return (
      <div className="sdsButtons">
        {buttons.map(index => (
          <button
            key={index}
            className={this.getClassNames(index)}
            onClick={() => this.handleSelectedButton(index)}
            disabled={disabled}
            data-cy={
              index === '0'
                ? 'sdsButton1'
                : index === '4'
                  ? 'sdsButton4'
                  : undefined
            }
          >
            <div className="sdsButtons-button--buttonStuff">
              <img src={ghsLabelMapper(index)} alt="severity" />
            </div>
          </button>
        ))}
      </div>
    );
  }
}

export default SdsButtons;
